import React, { useState, useMemo, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import TableContainer from "../../Common/TableContainer";
import { couponsList } from "../../Common/data";
import { Link, useNavigate } from 'react-router-dom';
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import *  as Yup from 'yup'
import moment from "moment";
import { yupResolver } from "@hookform/resolvers/yup";
import offerbanner from "../../assets/images/ecommerce/offer-banner.jpg";
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import { useForm } from 'react-hook-form';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import RHFileUpload from '../../FunctionalComponent/FormElement/RHFileUpload';
import { useCouponlistMutation, useCreate_Update_CouponMutation, useDeletecouponMutation, useGetCouponDataMutation, useGetCouponslistQuery } from '../../Redux/CouponSlice';
import { useUplaodFileMutation } from '../../Redux/file/fileApi';
import { useCategoryListMutation, useGetCategoriesListQuery } from '../../Redux/category/categoryApi';
import { getQueryString } from '../../lib/Validationtext';
import { useActiveProductlistMutation } from '../../Redux/ProductSlice';
import DeleteModal from '../../Common/modals/DeleteModal';
import { toast } from 'react-toastify'
import useDebounce from '../../hooks/useDebounce';



const Coupons = () => {
    const [search, setSearch] = useState('')
    document.title = "Coupons | Toner eCommerce + Admin React Template";
    const [fileUploadFn, { data: fileData }] = useUplaodFileMutation();
    const [CreateUpdateCouponFunc, { data: addSuccessData, isSuccess: addCouponSuccess, error: addErrCoupn, isLoading }] = useCreate_Update_CouponMutation();
    // const [categoryListFn, { data: listData, error: listErr, isLoading: listLoading }] = useCategoryListMutation();




    useEffect(() => {
        if (addCouponSuccess) {
            const message = addSuccessData?.message || "Coupon added  successfully";
            toast.success(message);

            setmodal_AddCouponsModals(false)

        }
        if (addErrCoupn) {
            if ('data' in addErrCoupn) {
                const errorData = addErrCoupn;
                toast.error(errorData.data.message);

            }
        }
    }, [addSuccessData, addCouponSuccess, addErrCoupn]);



    const debounceSearch = useDebounce(search, 300);
    const { data: listData, error: listErr, isLoading: listLoading } = useGetCategoriesListQuery();


    // const [couponlistFunc, { data: CouponlistData, }] = useCouponlistMutation();
    const { data: CouponlistData, isFetching } = useGetCouponslistQuery(debounceSearch);

    // const [ActiveProductlistFunc, { data: productlistData }] = useActiveProductlistMutation();
    // const { data: productlistData } = useGetActiveProductslistQuery();





    const [GetCouponFunc] = useGetCouponDataMutation();
    const [DeletecouponFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: deleteSuccess }] = useDeletecouponMutation();
    const [showCoupons, setShowCoupons] = useState(false);
    const [showCouponDetails, setShowCouponsDetails] = useState({});
    const [sliderImage, setsliderImage] = useState(null);
    const [couponImage, setcouponImage] = useState(null);
    const [page, setPage] = useState(0);
    const [limit, setlimit] = useState(10);
    const [modal_AddCouponsModals, setmodal_AddCouponsModals] = useState(false);
    const [CouponData, setCouponData] = useState();
    const [showModal, setShowModal] = useState(false);
    const defaultValues = {
        id: "",
        name: '',
        code: '',
        discountType: '',
        discountValue: '',
        maxUsageCount: '',
        startDate: '',
        endDate: '',
        isApplicableForPromo: '',
        sliderImage: '',
        couponImage: '',
        categoryId: [],
        productId: [],
        isShownHomePage: '',
        isActive: '',
        type: '', //promo,coupon
        isShownSticky: '',
    };

    const couponSchema = Yup.object().shape({
        name: Yup
            .string()
            .required()
            .strict(true)
            .trim('White spaces before and after are not allow'),
        code: Yup
            .string()
            .required()
            .strict(true)
            .trim('White spaces before and after are not allow'),
        isActive: Yup.string().required('Status is required'),
        discountType: Yup.string().required('Discount Type is required'),
        discountValue: Yup
            .number()
            .required(),
        // .strict(true)
        // .trim('White spaces before and after are not allow'),
        maxUsageCount: Yup.string().required('Coupon can use is required'),
        startDate: Yup.string().required('Start date use is required'),
        endDate: Yup.string().required('End date use is required'),
        isApplicableForPromo: Yup.string().required('Promo use is required'),

    });


    useEffect(() => {
        if (CouponData?.id) {
            GetCouponFunc(CouponData?.id).then(res => {
                const getsizedata = res?.data?.response
                Object.keys(defaultValues).forEach((fieldname) => {
                    let value = getsizedata[`${fieldname}`];

                    if (fieldname === 'startDate' || fieldname === 'endDate') {

                        setValue(fieldname, moment(getsizedata[fieldname]).format('YYYY-MM-DD'))
                    }

                    if (fieldname === 'categoryId') {
                        value = getsizedata?.CouponCategoryCombinations?.map(item => ({ label: item?.Category?.name, value: item?.Category?.id }));
                    } else if (fieldname === 'productId') {
                        value = getsizedata?.CouponProductCombinations?.map(item => ({ label: item?.Product?.productTitle, value: item?.Product?.id }));

                    }
                    setValue(fieldname, value);
                    // setValue({ ...fieldname, productId: productvalue });
                })
            })
        }
    }, [CouponData])

    useEffect(() => {
        if (deleteSuccess) {
            setShowModal(false)
            const message = deleteData?.message || "Delete successfully";
            toast.success(message);
            setCouponData({})
            // couponlistFunc(getQueryString({ page: page + 1, limit: limit }))
        }
        if (deleteErr) {
            if ('data' in deleteErr) {
                const errorData = deleteData;
                toast.error(errorData.data.message);

            }
        }
    }, [deleteData, deleteSuccess, deleteErr]);

    const handleFileChange = (e, setFile, name) => {
        const file = e.target.files?.[0];
        const fileName = e.target.name
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (reader.readyState === 2) {

                    setValue(fileName, reader.result, {
                        shouldDirty: true,
                        shouldTouch: true,
                        shouldValidate: true,
                    })
                }
            }
            reader.readAsDataURL(file);
            setFile(file)

        }
    }

    const uploadFile = async (file) => {
        if (!file) {
            // If there's no file to upload, resolve immediately
            return;
        }

        try {
            const formData = new FormData();
            formData.append("image", file);
            const response = await fileUploadFn(formData);
            return response?.data?.response?.url
        } catch (error) {
            throw error;
        }
    };




    const methods = useForm({
        resolver: yupResolver(couponSchema),
        defaultValues,
        mode: 'all',
    });

    const {
        reset,
        setError,
        setValue,
        handleSubmit,
        getValues,
        watch,
        formState: { errors },
    } = methods;

    function tog_AddCouponsModals() {
        // reset()
        setmodal_AddCouponsModals(!modal_AddCouponsModals);
    }
    const valuecheck = watch();
    const onSubmit = async (data) => {
        const productvalue = data?.productId.map(item => item.value);
        const categoryvalue = data?.categoryId.map(item => item.value);
        try {
            const promiseAll = await Promise.all([
                uploadFile(couponImage),
                uploadFile(sliderImage),
            ]);
            CreateUpdateCouponFunc({
                ...data, productId: productvalue, categoryId: categoryvalue, couponImage: promiseAll[0],
                sliderImage: promiseAll[1],
            }).then((res) => {

                if (res?.data?.statusCode == 200) {

                    setcouponImage(null)

                    setsliderImage(null)

                    // tog_AddCouponsModals()

                    // couponlistFunc(getQueryString({ page: page + 1, limit: limit }))

                }

            })
        } catch (error) {
            setError("afterSubmit", {
                ...error,
                message: error.message,
            });
        }

        // tog_AddCouponsModals()
    };
    const columns = useMemo(
        () => [
            {
                Header: "Discount",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    return (
                        <h5 className="mb-0 fs-16">{cellProps.discountValue}</h5>
                    )
                },
            },
            {
                Header: "Coupon Title",
                accessor: "name",
                disableFilters: true,
                filterable: true,
            },
            {
                Header: "Code",
                accessor: "code",
                disableFilters: true,
                filterable: true,
            },

            {
                Header: "Start Date",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => cellProps.startDate ? moment(cellProps.startDate).format('DD-MM-YYYY') : '-',

            },
            {
                Header: "End Date",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => cellProps.endDate ? moment(cellProps.endDate).format('DD-MM-YYYY') : '-',
            },
            {
                Header: "Status",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    switch (cellProps.isActive) {
                        case true:
                            return (<span className="badge bg-success-subtle text-success text-uppercase">Active</span>)
                        case false:
                            return (<span className="badge bg-danger-subtle text-danger text-uppercase">Expired</span>)
                        default:
                            return (<span className="badge bg-success-subtle text-success text-uppercase">oppss</span>)
                    }
                },
            },
            {
                Header: "Action",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    return (
                        <ul className="hstack gap-2 list-unstyled mb-0">
                            <li>
                                <Button data-bs-toggle="offcanvas" className="badge bg-dark-subtle text-body view-item-btn" onClick={() => { setShowCouponsDetails(cellProps); setShowCoupons(!showCoupons) }}>View</Button>
                            </li>
                            <li>
                                <Link to={`/coupons/add-coupon/${cellProps?.id}`} className="badge bg-primary-subtle text-primary edit-item-btn" data-bs-toggle="modal">
                                    Edit
                                </Link>
                            </li>
                            <li>
                                <Button data-bs-toggle="modal" className="badge bg-danger-subtle text-danger remove-item-btn" onClick={() => {
                                    setCouponData(cellProps)
                                    setShowModal(!showModal);
                                }}>Delete</Button>
                            </li>
                        </ul>
                    )
                },
            },
        ], [showCoupons]
    );
    const navigate = useNavigate()
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumb title="Coupons list" pageTitle="More" />
                    <div id="couponsList">
                        <Row>
                            <Col xxl={12}>
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center">
                                            <Col xxl={3} md={5}>
                                                <div className="search-box mb-3 mb-md-0">
                                                    <input type="text" className="form-control search" onChange={(e) => setSearch(e.target.value)} id="searchProductList" placeholder="Search by coupons code" />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </Col>
                                            <Col className="col-md-auto ms-auto">
                                                <Button variant='success' onClick={() => {
                                                    navigate('/coupons/add-coupon')
                                                }} className="add-btn"><i className="bi bi-plus-circle me-1 align-middle"></i>Add Coupon</Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <Card.Body className='p-0'>
                                        <TableContainer
                                            columns={(columns || [])}
                                            data={(CouponlistData?.response || [])}
                                            iscustomPageSize={false}
                                            isBordered={false}
                                            customPageSize={10}
                                            className="custom-header-css table align-middle table-nowrap"
                                            tableClass="table-centered align-middle table-nowrap mb-0"
                                            theadClass="text-muted table-light"
                                            SearchPlaceholder='Search Products...'
                                        />
                                        <div className="noresult" style={{ display: "none" }}>
                                            <div className="text-center">
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                                <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <Modal id="showModal" className="fade zoomIn" size="lg" centered>
                        <Modal.Header className="px-4 pt-4" closeButton>
                            <h5 className="modal-title fs-18" id="exampleModalLabel">Add Coupons</h5>
                        </Modal.Header>
                        <Modal.Body className="p-4">
                            <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHFTextField name='name' label='Coupon Title' required />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHFTextField name='code' label='Coupon Code' required />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHSelectField name='discountType' label='Discount Type' list={[
                                                { name: 'Fixed', value: 'fixed' },
                                                { name: 'Percentage', value: 'percentage' },
                                            ]} />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHFTextField name='discountValue' label='Discount Value' required />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHSelectField
                                                list={[
                                                    { name: "Once", value: 1 },
                                                    { name: "Twice", value: 2 },
                                                    { name: "Unlimited", value: 3 },
                                                ]}
                                                label="Coupon can use"
                                                name="maxUsageCount"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="startDate">Start Date</Form.Label>
                                            <Flatpickr
                                                className="form-control flatpickr-input"
                                                placeholder='Select date'
                                                options={{
                                                    dateFormat: "d M, Y",
                                                }}
                                                onChange={(e) => setValue('startDate', e?.[0])}
                                                value={getValues('startDate')}
                                            />
                                            <div>{errors?.startDate?.message}</div>
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="endDate">End Date</Form.Label>
                                            <Flatpickr
                                                className="form-control flatpickr-input"
                                                placeholder='Select date'
                                                options={{
                                                    dateFormat: "d M, Y",
                                                }}
                                                onChange={(e) => setValue('endDate', e?.[0])}
                                                value={getValues('endDate')}
                                            />
                                            <div>{errors?.endDate?.message}</div>
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHSelectField name='isApplicableForPromo' label='Promo'
                                                onChange={(e) => {
                                                    setValue('isApplicableForPromo', e.target.value)
                                                    if (e.target.value == 'true') {
                                                        setValue('type', 'promo')
                                                    } else {
                                                        setValue('type', 'coupon')
                                                    }
                                                }
                                                }
                                                list={[
                                                    { name: 'Not Applicable', value: false },
                                                    { name: 'Applicable', value: true },
                                                ]} />
                                        </div>
                                    </Col>
                                    {/* 
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="sliderImage" className="form-label d-block">Slider Image
                                                {/* <span className="text-danger">*</span> 
                                            </Form.Label>
                                            <div className="position-relative d-inline-block">
                                                <div className="position-absolute top-100 start-100 translate-middle">
                                                    <Form.Label htmlFor="sliderImage" className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="Select Category Image">
                                                        <span className="avatar-xs d-inline-block">
                                                            <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                                                <i className="ri-image-fill"></i>
                                                            </span>
                                                        </span>
                                                    </Form.Label>
                                                    <input className="form-control d-none" name='sliderImage' id="sliderImage" type="file" accept="image/png, image/gif, image/jpeg" onChange={e => handleFileChange(e, setsliderImage)} />
                                                </div>



                                                <div className="avatar-lg">
                                                    {getValues('sliderImage') ? <div className="avatar-title bg-light w-100  rounded-3">
                                                        <img src={getValues('sliderImage')} alt="" id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                                                    </div> :
                                                        <div className="avatar-title bg-light rounded-3">
                                                            <img src="#" alt="" id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                                                        </div>}
                                                </div>

                                            </div>

                                            <div className="error-msg mt-1">Please add a slider images.</div>
                                        </div>
                                    </Col> 
                                 <Col lg={6}>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="couponImage" className="form-label d-block">Coupon Image </Form.Label>

                                            <div className="position-relative d-inline-block">
                                                <div className="position-absolute top-100 start-100 translate-middle">
                                                    <Form.Label htmlFor="couponImage" className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="Select Category Image">
                                                        <span className="avatar-xs d-inline-block">
                                                            <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                                                <i className="ri-image-fill"></i>
                                                            </span>
                                                        </span>
                                                    </Form.Label>
                                                    <input className="form-control d-none" name='couponImage' id="couponImage" type="file" accept="image/png, image/gif, image/jpeg" onChange={e => handleFileChange(e, setcouponImage)} />
                                                </div>
                                                <div className="avatar-lg">
                                                    {getValues('couponImage') ? <div className="avatar-title bg-light rounded-3">
                                                        <img src={getValues('couponImage')} alt="" id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                                                    </div> :
                                                        <div className="avatar-title bg-light rounded-3">
                                                            <img src="#" alt="" id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                                                        </div>}


                                                </div>

                                            </div>

                                            <div className="error-msg mt-1">Please add a coupon images.</div>
                                        </div>
                                    </Col> */}
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <Select
                                                name='categoryId'
                                                isMulti
                                                options={listData?.response?.length && listData?.response?.map(item => ({ label: item?.name, value: item?.id })) || [{}]}
                                                placeholder="Select options"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '0.25rem',
                                                        boxShadow: 'none',
                                                        '&:hover': {
                                                            borderColor: '#ced4da',
                                                        },
                                                    }),
                                                    multiValueLabel: (provided) => ({
                                                        ...provided,
                                                        color: '#fff',
                                                        backgroundColor: '#007bff',
                                                    }),
                                                    multiValueRemove: (provided) => ({
                                                        ...provided,
                                                        color: '#fff',
                                                        backgroundColor: '#007bff',
                                                        borderRadius: '0.25rem',
                                                        '&:hover': {
                                                            backgroundColor: '#0056b3',
                                                        },
                                                    }),
                                                }}
                                                onChange={(e) => {
                                                    setValue('categoryId', e)
                                                }}
                                                value={getValues('categoryId')}
                                            />
                                        </div>
                                    </Col>
                                    {/* <Col lg={3}>
                  <div className="mb-3">
                    <RHSelectField name='isApplicableForPromo' label='Promo'
                      onChange={(e) => {
                        setValue('isApplicableForPromo', e.target.value)
                        if (e.target.value == true) {
                          setValue('type', 'promo')
                        } else {
                          setValue('type', 'coupon')
                        }
                      }
                      }
                      list={[
                        { name: 'Not Applicable', value: false },
                        { name: 'Applicable', value: true },
                      ]} />
                  </div>
                </Col> */}
                                    {/*  <Col lg={3}>
                  <div className="mb-3">
                    <RHSelectField name='type' label='Type' list={[
                      { name: 'coupon', value: 'coupon' },
                      { name: 'promo', value: 'promo' },
                    ]} />
                  </div>
                </Col> */}
                                    {/* <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Promo</Form.Label>
                    <Form.Select
                      name='isApplicableForPromo'
                      onChange={(e) => setValue('isApplicableForPromo', e.target.value)}
                      value={"isApplicableForPromo" ? 'true' : 'false'}
                    >
                      <option value='false'>Not Applicable</option>
                      <option value='true'>Applicable</option>
                    </Form.Select>
                  </Form.Group>
                </Col> */}
                                    {/* <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      name='type'
                      value={"type"}
                      disabled={"isApplicableForPromo"}
                    >
                      <option value='coupon'>Coupon</option>
                      <option value='promo'>Promo</option>
                    </Form.Select>
                  </Form.Group>
                </Col> */}
                                    {/* <Col lg={6}>
                                        <div className="mb-3">
                                            <Select
                                                name='productId'
                                                isMulti
                                                options={productlistData?.response?.length && productlistData?.response?.map(item => (
                                                    { label: item?.productTitle, value: item?.id })) || [{}]}
                                                placeholder="Select options"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        border: '1px solid #ced4da', // Bootstrap-style border
                                                        borderRadius: '0.25rem', // Bootstrap-style border radius
                                                        boxShadow: 'none', // Remove box shadow
                                                        '&:hover': {
                                                            borderColor: '#ced4da', // Border color on hover
                                                        },
                                                    }),
                                                    multiValueLabel: (provided) => ({
                                                        ...provided,
                                                        color: '#fff', // Text color for selected options
                                                        backgroundColor: '#007bff', // Background color for selected options
                                                    }),
                                                    multiValueRemove: (provided) => ({
                                                        ...provided,
                                                        color: '#fff', // Remove button color for selected options
                                                        backgroundColor: '#007bff', // Background color for selected options
                                                        borderRadius: '0.25rem', // Bootstrap-style border radius
                                                        '&:hover': {
                                                            backgroundColor: '#0056b3', // Background color on hover
                                                        },
                                                    }),
                                                }}
                                                onChange={(e) => {

                                                    setValue('productId', e)
                                                }}
                                                value={getValues('productId')}
                                            />
                                        </div>
                                    </Col> */}
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHSelectField name='isActive' label='Status' list={[
                                                { name: 'Active', value: true },
                                                { name: 'Expired', value: false },
                                            ]} />
                                        </div>
                                    </Col>
                                    <Col lg={6}>

                                        <div className="mb-3">
                                            <RHSelectField name='isShownSticky' label='Sticky' list={[
                                                { name: 'Applicable', value: true },
                                                { name: 'Not Applicable', value: false },
                                            ]} />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHSelectField name='isShownHomePage' label='Home Page' list={[
                                                { name: 'Applicable', value: true },
                                                { name: 'Not Applicable', value: false },
                                            ]} />
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="mb-3">
                                            <RHSelectField name='type' label='Type' list={[
                                                { name: 'coupon', value: 'coupon' },
                                                { name: 'promo', value: 'promo' },
                                            ]} />
                                        </div>
                                    </Col>
                                    <Col lg={12} className="modal-footer">
                                        <div className="hstack gap-2 justify-content-end">
                                            <Button className="btn-ghost-danger" onClick={() => { tog_AddCouponsModals(); }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
                                            <Button variant='primary' id="add-btn" type='submit'>Add Coupons</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </FormProvider>
                        </Modal.Body>
                    </Modal>

                </Container>
            </div>
            <Offcanvas show={showCoupons} onHide={() => setShowCoupons(!showCoupons)} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Coupon Details</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div style={{ marginLeft: 70 }}>
                        <div style={{ marginBottom: 20 }} >
                            {/* <span className="text-muted">Coupon Image</span> */}
                            <img src={showCouponDetails.couponImage} alt="" className="img-thumbnail" style={{ width: 200, height: 200 }} />
                        </div>
                        {/* <div>
                            <span className="text-muted">Slider Image</span>
                            <img src={showCouponDetails.sliderImage} alt="" className="img-thumbnail" style={{ width: 200, height: 200 }} />
                        </div> */}
                    </div>
                    <div className="mt-3">
                        <div className="table-responsive">
                            <table className="table table-borderless">
                                <tbody>
                                    <tr>
                                        <td><span className="text-muted">Coupon Tittle:</span></td>
                                        <td><span className="fw-medium">{showCouponDetails.name}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="text-muted">Use Code:</span></td>
                                        <td><span className="fw-medium">{showCouponDetails.code}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="text-muted">Discount:</span></td>
                                        <td><span className="fw-medium text-uppercase">{showCouponDetails.discountValue}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="text-muted">Start Date:</span></td>
                                        <td><span className="fw-medium">{showCouponDetails.startDate ? moment(showCouponDetails.startDate).format('DD-MM-YYYY') : '-'}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="text-muted">END Date:</span></td>
                                        <td><span className="fw-medium">{showCouponDetails.endDate ? moment(showCouponDetails.endDate).format('DD-MM-YYYY') : '-'}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="text-muted">Status:</span></td>
                                        <td><span className={showCouponDetails.isActive != true ? "badge bg-danger-subtle text-danger text-uppercase" : "badge bg-success-subtle text-success text-uppercase"}>{showCouponDetails.isActive != true ? 'Expired' : "Active"}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} handleSubmit={() => DeletecouponFunc({ id: CouponData?.id })} data={CouponData} />}
        </React.Fragment >
    );
};

export default Coupons;
